import { createAction } from 'typesafe-actions';

import { getNow } from '../../../../lib/TimeUtils';
import {
  DefaultFieldNames,
  Events,
  StatsActions,
  TTMActions,
  TTMAudioTypes,
  VoiceTrackMetricTypes,
} from '../constants';
import * as D from '../deps';
import TimeToMusicEvent from '../models/TimeToMusicEvent';

const AnalyticsActions = D.Constants.Analytics.ActionTypes;

export const clearStatsEvents = createAction(AnalyticsActions.CLEAR_STATS_EVENTS)();
export type ClearStatsEventsAction = ReturnType<typeof clearStatsEvents>;

interface ExpireValueExchangeRewardPayload {
  rewardType: $TSFixMe;
  expirationTrigger: $TSFixMe;
}

export const expireReward = createAction(
  AnalyticsActions.EXPIRE_VALUE_EXCHANGE_REWARD,
  (rewardType: $TSFixMe, expirationTrigger: $TSFixMe) => ({ rewardType, expirationTrigger }),
)<ExpireValueExchangeRewardPayload>();
export type ExpireValueExchangeRewardAction = ReturnType<typeof expireReward>;

interface AddEventPayload {
  events: $TSFixMe[];
}

export const addEvents = createAction(
  AnalyticsActions.ADD_EVENT,
  (events: $TSFixMe[], defaultEventData: $TSFixMe) => {
    /* the event data overrides the default event data, for ex. page_view */
    const actionEvents = events.map(event => {
      event.eventData = Object.assign({}, defaultEventData, event.eventData);
      return event;
    });

    return { events: actionEvents };
  },
)<AddEventPayload>();
export type AddEventAction = ReturnType<typeof addEvents>;

export const incrementSearchSequence = createAction(AnalyticsActions.INCREMENT_SEARCH_SEQUENCE)();
export type IncrementSearchSequenceAction = ReturnType<typeof incrementSearchSequence>;

export const resetSearchSequence = createAction(AnalyticsActions.RESET_SEARCH_SEQUENCE)();
export type ResetSearchSequenceAction = ReturnType<typeof resetSearchSequence>;

export const generateBrowseSessionId = createAction(AnalyticsActions.GENERATE_BROWSE_SESSION_ID)();
export type GenerateBrowseSessionIdAction = ReturnType<typeof generateBrowseSessionId>;

interface WebRegistrationParams {
  registrationEventAction: $TSFixMe;
}

export const logWebRegistrationEvent = createAction(
  Events.WEB_REGISTRATION,
  ({ registrationEventAction }: WebRegistrationParams) => ({ registrationEventAction }),
)<WebRegistrationParams>();
export type WebRegistrationAction = ReturnType<typeof logWebRegistrationEvent>;

interface StationStartedParams extends $TSFixMe {}

export const logStationStarted = createAction(
  AnalyticsActions.STATION_STARTED,
  (payload: StationStartedParams) => payload,
)<StationStartedParams>();
export type StationStartedAction = ReturnType<typeof logStationStarted>;

export const logEnterRedeemFlowForUrl = createAction(AnalyticsActions.ENTER_REDEEM_FLOW_FOR_URL)();
export type EnterRedeemFlowForUrlAction = ReturnType<typeof logEnterRedeemFlowForUrl>;

type LogBrowserAutoplayPlaybackParams = $TSFixMe;

interface LogBrowserAutoplayPlaybackPayload {
  action: LogBrowserAutoplayPlaybackParams;
}

export const logBrowserAutomaticPlayback = createAction(
  AnalyticsActions.LOG_BROWSER_AUTOPLAY_PLAYBACK,
  (listenerAction: LogBrowserAutoplayPlaybackParams) => ({ action: listenerAction }),
)<LogBrowserAutoplayPlaybackPayload>();
export type LogBrowserAutoplayPlaybackAction = ReturnType<typeof logBrowserAutomaticPlayback>;

interface LogPlaybackInteractionsParams {
  action: $TSFixMe;
  userInitiated: $TSFixMe;
}

export const logPlaybackInteractions = createAction(
  AnalyticsActions.LOG_PLAYBACK_INTERACTIONS,
  (params: LogPlaybackInteractionsParams) => params,
)<LogPlaybackInteractionsParams>();
export type LogPlaybackInteractionsAction = ReturnType<typeof logPlaybackInteractions>;

interface LogAdBlockerHammerCoachmarkParams {
  reason: $TSFixMe;
  clicked: $TSFixMe;
}

export const logAdBlockerHammerModalEvent = createAction(
  AnalyticsActions.LOG_AD_BLOCKER_HAMMER_COACHMARK,
  (params: LogAdBlockerHammerCoachmarkParams) => params,
)<LogAdBlockerHammerCoachmarkParams>();
export type LogAdBlockerHammerCoachmarkAction = ReturnType<typeof logAdBlockerHammerModalEvent>;

interface WebDisplayAdRequestParams extends $TSFixMe {}

export const logWebDisplayAdRequestEvent = createAction(
  AnalyticsActions.WEB_DISPLAY_AD_REQUEST,
  (params: WebDisplayAdRequestParams) => params,
)<WebDisplayAdRequestParams>();
export type WebDisplayAdRequestAction = ReturnType<typeof logWebDisplayAdRequestEvent>;

interface LogPremiumPlaylistUnlockedParams extends $TSFixMe {}

export const logPremiumPlaylistUnlocked = createAction(
  AnalyticsActions.LOG_PREMIUM_PLAYLIST_UNLOCKED,
  (params: LogPremiumPlaylistUnlockedParams) => params,
)<LogPremiumPlaylistUnlockedParams>();
export type LogPremiumPlaylistUnlockedAction = ReturnType<typeof logPremiumPlaylistUnlocked>;

type LogPremiumPlaylistCoachmarkParams = $TSFixMe;

interface LogPremiumPlaylistCoachmarkPayload {
  reason: LogPremiumPlaylistCoachmarkParams;
}

export const logPremiumPlaylistCoachmark = createAction(
  AnalyticsActions.LOG_PREMIUM_PLAYLIST_COACHMARK,
  (reason: LogPremiumPlaylistCoachmarkParams) => ({ reason }),
)<LogPremiumPlaylistCoachmarkPayload>();
export type LogPremiumPlaylistCoachmarkAction = ReturnType<typeof logPremiumPlaylistCoachmark>;

export const logAdBlockerAudioMessageCoachmark = createAction(
  AnalyticsActions.LOG_AD_BLOCKER_AUDIO_MESSAGE_COACHMARK,
)();
export type LogAdBlockerAudioMessageCoachmarkAction = ReturnType<
  typeof logAdBlockerAudioMessageCoachmark
>;

interface WebDisplayAdResponseParams extends $TSFixMe {}

export const logWebDisplayAdResponseEvent = createAction(
  AnalyticsActions.WEB_DISPLAY_AD_RESPONSE,
  (params: WebDisplayAdResponseParams) => params,
)<WebDisplayAdResponseParams>();
export type WebDisplayAdResponseAction = ReturnType<typeof logWebDisplayAdResponseEvent>;

interface WebDisplayAdIasPetRequestParams extends $TSFixMe {}

export const logWebDisplayAdIasPETRequestEvent = createAction(
  AnalyticsActions.WEB_DISPLAY_AD_IAS_PET_REQUEST,
  (params: WebDisplayAdIasPetRequestParams) => params,
)<WebDisplayAdIasPetRequestParams>();
export type WebDisplayAdIasPetRequestAction = ReturnType<typeof logWebDisplayAdIasPETRequestEvent>;

interface WebDisplayAdIasPetResponseParams extends $TSFixMe {}

export const logWebDisplayAdIasPETResponseEvent = createAction(
  AnalyticsActions.WEB_DISPLAY_AD_IAS_PET_RESPONSE,
  (params: WebDisplayAdIasPetResponseParams) => params,
)<WebDisplayAdIasPetResponseParams>();
export type WebDisplayAdIasPetResponseAction = ReturnType<
  typeof logWebDisplayAdIasPETResponseEvent
>;

interface WebDisplayAdStartRenderParams extends $TSFixMe {}

export const logWebDisplayAdStartRenderEvent = createAction(
  AnalyticsActions.WEB_DISPLAY_AD_START_RENDER,
  (params: WebDisplayAdStartRenderParams) => params,
)<WebDisplayAdStartRenderParams>();
export type WebDisplayAdStartRenderAction = ReturnType<typeof logWebDisplayAdStartRenderEvent>;

interface WebDisplayAdFinishRenderParams extends $TSFixMe {}

export const logWebDisplayAdFinishRenderEvent = createAction(
  AnalyticsActions.WEB_DISPLAY_AD_FINISH_RENDER,
  (params: WebDisplayAdFinishRenderParams) => params,
)<WebDisplayAdFinishRenderParams>();
export type WebDisplayAdFinishRenderAction = ReturnType<typeof logWebDisplayAdFinishRenderEvent>;

interface WebDisplayAdDismissedParams extends $TSFixMe {}

export const logWebDisplayAdDismissedEvent = createAction(
  AnalyticsActions.WEB_DISPLAY_AD_DISMISSED,
  (params: WebDisplayAdDismissedParams) => params,
)<WebDisplayAdDismissedParams>();
export type WebDisplayAdDismissedAction = ReturnType<typeof logWebDisplayAdDismissedEvent>;

interface StationCreatedParams {
  componentName: $TSFixMe;
  stationId: $TSFixMe;
  createStationParams: $TSFixMe;
}

export const logStationCreated = createAction(
  AnalyticsActions.STATION_CREATED,
  ({ componentName = null, stationId, createStationParams = {} }: StationCreatedParams) => ({
    stationId,
    componentName,
    createStationParams,
  }),
)<StationCreatedParams>();
export type StationCreatedAction = ReturnType<typeof logStationCreated>;

export const clearLiveTracking = createAction(AnalyticsActions.CLEAR_LIVE_TRACKING)();
export type ClearLiveTrackingAction = ReturnType<typeof clearLiveTracking>;

export const clearStats = createAction(AnalyticsActions.CLEAR_STATS)();
export type ClearStatsAction = ReturnType<typeof clearStats>;

interface LogConcertNotificationSentParams {
  eventId: $TSFixMe;
  artistId: $TSFixMe;
  actionType: $TSFixMe;
  actionLink: $TSFixMe;
  notificationId: $TSFixMe;
}

export const logConcertNotificationSent = createAction(
  AnalyticsActions.LOG_CONCERT_NOTIFICATION_SENT,
  (params: LogConcertNotificationSentParams) => params,
)<LogConcertNotificationSentParams>();
export type LogConcertNotificationSentAction = ReturnType<typeof logConcertNotificationSent>;

interface LogConcertNotificationViewedParams {
  eventId: $TSFixMe;
  artistId: $TSFixMe;
  actionType: $TSFixMe;
  actionLink: $TSFixMe;
  notificationId: $TSFixMe;
}

export const logConcertNotificationViewed = createAction(
  AnalyticsActions.LOG_CONCERT_NOTIFICATION_VIEWED,
  (params: LogConcertNotificationViewedParams) => params,
)<LogConcertNotificationViewedParams>();
export type LogConcertNotificationViewedAction = ReturnType<typeof logConcertNotificationViewed>;

type LogConcertNotificationNoLongerOnPageParams = $TSFixMe;

interface LogConcertNotificationNoLongerOnPagePayload {
  eventId: LogConcertNotificationNoLongerOnPageParams;
}

export const logConcertNotificationNoLongerOnPage = createAction(
  AnalyticsActions.LOG_CONCERT_NOTIFICATION_NO_LONGER_ON_PAGE,
  (eventId: LogConcertNotificationNoLongerOnPageParams) => ({ eventId }),
)<LogConcertNotificationNoLongerOnPagePayload>();
export type LogConcertNotificationNoLongerOnPageAction = ReturnType<
  typeof logConcertNotificationNoLongerOnPage
>;

interface LogConcertNotificationClickedParams {
  eventId: $TSFixMe;
  artistId: $TSFixMe;
  actionLink: $TSFixMe;
  notificationId: $TSFixMe;
}

export const logConcertNotificationClicked = createAction(
  AnalyticsActions.LOG_CONCERT_NOTIFICATION_CLICKED,
  (params: LogConcertNotificationClickedParams) => params,
)<LogConcertNotificationClickedParams>();
export type LogConcertNotificationClickedAction = ReturnType<typeof logConcertNotificationClicked>;

interface AddVarietyParams {
  variety_id: $TSFixMe;
}

type AddVarietyPayload = AddVarietyParams & {
  add_variety_type: ReturnType<typeof D.Utils.Entity.getEntityTrackingType>;
};

export const logAddVariety = createAction(
  AnalyticsActions.ADD_VARIETY,
  (params: AddVarietyParams) => {
    const add_variety_type = D.Utils.Entity.getEntityTrackingType(params.variety_id);
    return { ...params, add_variety_type };
  },
)<AddVarietyPayload>();
export type AddVarietyAction = ReturnType<typeof logAddVariety>;

interface DeleteStationPayload {
  stationId: $TSFixMe;
  componentName: $TSFixMe;
}

export const logDeleteStation = createAction(
  AnalyticsActions.DELETE_STATION,
  (stationId: $TSFixMe, componentName: $TSFixMe) => ({ stationId, componentName }),
)<DeleteStationPayload>();
export type DeleteStationAction = ReturnType<typeof logDeleteStation>;

interface ShuffleEditParams {
  stations: $TSFixMe;
  station_id: $TSFixMe;
  shuffleType: $TSFixMe;
}

type ShuffleEditPayload = Exclude<ShuffleEditParams, 'shuffleType'> & {
  type: typeof Events.QUICK_MIX_EDIT;
  shuffle_type: ShuffleEditParams['shuffleType'];
};

export const logShuffleEdit = createAction(
  AnalyticsActions.SHUFFLE_EDIT,
  ({ stations, station_id, shuffleType }: ShuffleEditParams) => ({
    stations,
    station_id,
    type: Events.QUICK_MIX_EDIT,
    shuffle_type: shuffleType,
  }),
)<ShuffleEditPayload>();
export type ShuffleEditAction = ReturnType<typeof logShuffleEdit>;

interface LogWebViewModeEventPayload {
  [DefaultFieldNames.PAGE_VIEW]: $TSFixMe;
  [DefaultFieldNames.VIEW_MODE]: $TSFixMe;
}

export const logWebViewModeEvent = createAction(
  AnalyticsActions.LOG_WEB_VIEW_MODE_EVENT,
  (pageView: $TSFixMe, viewMode: $TSFixMe) => ({
    [DefaultFieldNames.PAGE_VIEW]: pageView,
    [DefaultFieldNames.VIEW_MODE]: viewMode,
  }),
)<LogWebViewModeEventPayload>();
export type LogWebViewModeEventAction = ReturnType<typeof logWebViewModeEvent>;

interface LogBackstageEventParams extends $TSFixMe {}

export const logBackstageEvent = createAction(
  AnalyticsActions.LOG_BACKSTAGE_EVENT,
  (params: LogBackstageEventParams) => params,
)<LogBackstageEventParams>();
export type LogBackstageEventAction = ReturnType<typeof logBackstageEvent>;

export const logSkipLimit = createAction(AnalyticsActions.LOG_SKIP_LIMIT_STATS)();
export type LogSkipLimitStatsAction = ReturnType<typeof logSkipLimit>;

interface LogTrackEndStationPayload {
  reason: $TSFixMe;
  track: $TSFixMe;
}

export const logTrackEndStation = createAction(
  AnalyticsActions.LOG_TRACK_END_STATION,
  (reason: $TSFixMe, track: $TSFixMe) => ({ reason, track }),
)<LogTrackEndStationPayload>();
export type LogTrackEndStationAction = ReturnType<typeof logTrackEndStation>;

interface LogTrackEndParams {
  reason: $TSFixMe;
  track: $TSFixMe;
  token: $TSFixMe;
  playlistId: $TSFixMe;
  playlistType: $TSFixMe;
  duration: $TSFixMe;
  currentTime: $TSFixMe;
}

export const logTrackEnd = createAction(
  AnalyticsActions.LOG_TRACK_END,
  (params: LogTrackEndParams) => params,
)<LogTrackEndParams>();
export type LogTrackEndAction = ReturnType<typeof logTrackEnd>;

/*
 * Used to create stats object for audio_track_playback_event
 */

interface AudioTrackPlaybackStatsParams extends $TSFixMe {}

export const createAudioTrackPlaybackEvent = createAction(
  AnalyticsActions.AUDIO_TRACK_PLAYBACK_STATS,
  (eventData: AudioTrackPlaybackStatsParams = {}) => eventData,
)<AudioTrackPlaybackStatsParams>();
export type AudioTrackPlaybackStatsAction = ReturnType<typeof createAudioTrackPlaybackEvent>;

interface LogFpsDataParams {
  fps: $TSFixMe;
}

interface LogFpsDataPayload {
  frames_per_second: LogFpsDataParams['fps'];
}

export const logFPSEvent = createAction(
  AnalyticsActions.LOG_FPS_DATA,
  (eventData: LogFpsDataParams) => ({ frames_per_second: eventData.fps }),
)<LogFpsDataPayload>();
export type LogFpsDataAction = ReturnType<typeof logFPSEvent>;

interface LogReplayTrackPayload {
  trackToken: $TSFixMe;
  eventSource: $TSFixMe;
}

export const logReplayTrackEvent = createAction(
  AnalyticsActions.LOG_REPLAY_TRACK,
  (trackToken: $TSFixMe = null, eventSource: $TSFixMe = 'other') => ({ trackToken, eventSource }),
)<LogReplayTrackPayload>();
export type LogReplayTrackAction = ReturnType<typeof logReplayTrackEvent>;

type PlayedPaWelcomeAudioParams = $TSFixMe;

interface PlayedPaWelcomeAudioPayload {
  sourceType: PlayedPaWelcomeAudioParams;
}

export const logPlayPAWelcomeAudio = createAction(
  Events.PLAYED_PA_WELCOME_AUDIO,
  (sourceType: PlayedPaWelcomeAudioParams) => sourceType,
)<PlayedPaWelcomeAudioPayload>();
export type PlayedPaWelcomeAudioAction = ReturnType<typeof logPlayPAWelcomeAudio>;

interface OpenedLtuxPaUpsellCoachmarkParams extends $TSFixMe {}

export const logOpenedLTUXPAUpsellCoachmark = createAction(
  Events.OPENED_LTUX_PA_UPSELL_COACHMARK,
  (params: OpenedLtuxPaUpsellCoachmarkParams) => params,
)<OpenedLtuxPaUpsellCoachmarkParams>();
export type OpenedLtuxPaUpsellCoachmarkAction = ReturnType<typeof logOpenedLTUXPAUpsellCoachmark>;

interface ClickedLtuxPaUpsellCoachmarkParams extends $TSFixMe {}

export const logClickedLTUXPAUpsellCoachmark = createAction(
  Events.CLICKED_LTUX_PA_UPSELL_COACHMARK,
  (params: ClickedLtuxPaUpsellCoachmarkParams) => params,
)<ClickedLtuxPaUpsellCoachmarkParams>();
export type ClickedLtuxPaUpsellCoachmarkAction = ReturnType<typeof logClickedLTUXPAUpsellCoachmark>;

interface ClickedStartTrialPaUpsellCoachmarkParams extends $TSFixMe {}

export const logClickedStartTrialPAUpsellCoachmark = createAction(
  Events.CLICKED_START_TRIAL_PA_UPSELL_COACHMARK,
  (params: ClickedStartTrialPaUpsellCoachmarkParams) => params,
)<ClickedStartTrialPaUpsellCoachmarkParams>();
export type ClickedStartTrialPaUpsellCoachmarkAction = ReturnType<
  typeof logClickedStartTrialPAUpsellCoachmark
>;

interface LogEventsParams extends $TSFixMe {}

export const logEvents = createAction(
  D.Constants.UseCases.ActionTypes.LOG_EVENTS,
  (params: LogEventsParams) => params,
)<LogEventsParams>();
export type LogEventsAction = ReturnType<typeof logEvents>;

interface LogAbExperimentDiversionPointParams {
  experimentId: $TSFixMe;
  treatmentId: $TSFixMe;
}

export const logAbExperimentDiversionPoint = createAction(
  AnalyticsActions.LOG_AB_EXPERIMENT_DIVERSION_POINT,
  (params: LogAbExperimentDiversionPointParams) => params,
)<LogAbExperimentDiversionPointParams>();
export type LogAbExperimentDiversionPointAction = ReturnType<typeof logAbExperimentDiversionPoint>;

interface LogRecentlyPlayedCarouselEventParams extends $TSFixMe {}

export const logRecentlyPlayedCarouselEvent = createAction(
  AnalyticsActions.LOG_RECENTLY_PLAYED_CAROUSEL_EVENT,
  (params: LogRecentlyPlayedCarouselEventParams) => params,
)<LogRecentlyPlayedCarouselEventParams>();
export type LogRecentlyPlayedCarouselEventAction = ReturnType<
  typeof logRecentlyPlayedCarouselEvent
>;

type LogVoiceTrackMetricType =
  | typeof VoiceTrackMetricTypes.AUDIO_IMPRESSION
  | typeof VoiceTrackMetricTypes.AUDIO_TILE_CLICK
  | typeof VoiceTrackMetricTypes.AUDIO_TILE_IMPRESSION
  | typeof VoiceTrackMetricTypes.SKIP;

interface LogVoiceTrackMetricParams {
  authorId: $TSFixMe;
  messageId: $TSFixMe;
  sourceId: $TSFixMe;
}

type LogVoiceTrackMetricPayload = LogVoiceTrackMetricParams & { type: LogVoiceTrackMetricType };

const voiceTrackMetricAction = (type: LogVoiceTrackMetricType): $TSFixMe =>
  createAction(AnalyticsActions.LOG_VOICE_TRACK_METRIC, (params: LogVoiceTrackMetricParams) => ({
    ...params,
    type,
  }))<LogVoiceTrackMetricPayload>();
export type LogVoiceTrackMetricAction = ReturnType<typeof voiceTrackMetricAction>;

export const logVoiceTrackAudioImpression = voiceTrackMetricAction(
  VoiceTrackMetricTypes.AUDIO_IMPRESSION,
);
export const logVoiceTrackAudioTileClick = voiceTrackMetricAction(
  VoiceTrackMetricTypes.AUDIO_TILE_CLICK,
);
export const logVoiceTrackAudioTileImpression = voiceTrackMetricAction(
  VoiceTrackMetricTypes.AUDIO_TILE_IMPRESSION,
);
export const logVoiceTrackSkip = voiceTrackMetricAction(VoiceTrackMetricTypes.SKIP);

interface TtmStartPayload {
  ttmAction: $TSFixMe;
  timeStart: number;
  audioType: $TSFixMe;
}

const timeToMusicStartAction = createAction(
  StatsActions.TTM_START,
  (ttmAction: TtmStartPayload['ttmAction'], audioType?: TtmStartPayload['audioType']) =>
    TimeToMusicEvent({
      ttmAction,
      timeStart: getNow(),
      audioType,
    }),
)<$TSFixMe>();
export type TtmStartAction = ReturnType<typeof timeToMusicStartAction>;

export const ttmTrackSkippedTransitionFromMusic = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.TRACK_SKIPPED);
export const ttmTrackSkippedTransitionFromVideoAd = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.TRACK_SKIPPED, TTMAudioTypes.VIDEO_AD);
export const ttmTrackThumbsDownTransitionFromMusic = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.TRACK_THUMBS_DOWN);
export const ttmTrackThumbsDownTransitionFromVideoAd = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.TRACK_THUMBS_DOWN, TTMAudioTypes.VIDEO_AD);
export const ttmSourceChangedTransitionFromMusic = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.SOURCE_CHANGED, TTMAudioTypes.MUSIC);
export const ttmPlaybackResumedTransitionFromMusic = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.PLAYBACK_RESUMED, TTMAudioTypes.MUSIC);
export const ttmStillListening = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.STILL_LISTENING, TTMAudioTypes.MUSIC);
export const ttmNonAdInterruption = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.NON_AD_INTERRUPTION, TTMAudioTypes.NON_AD_INTERRUPTION);
export const ttmAudioAd = (audioType = TTMAudioTypes.MUSIC): TtmStartAction =>
  timeToMusicStartAction(TTMActions.AUDIO_AD, audioType);
export const ttmVideoAd = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.VIDEO_AD, TTMAudioTypes.MUSIC);
export const ttmNoUserAction = (): TtmStartAction =>
  timeToMusicStartAction(TTMActions.NO_USER_ACTION, TTMAudioTypes.MUSIC);

interface TtmCancelPayload {
  ttmAction: $TSFixMe;
}

// Remove a single time to music event
const timeToMusicCancel = createAction(StatsActions.TTM_CANCEL, (ttmAction: $TSFixMe) => ({
  ttmAction,
}))<TtmCancelPayload>();
export type TtmCancelAction = ReturnType<typeof timeToMusicCancel>;

export const ttmTrackSkippedCancel = (): TtmCancelAction =>
  timeToMusicCancel(TTMActions.TRACK_SKIPPED);
export const ttmTrackThumbsDownCancel = (): TtmCancelAction =>
  timeToMusicCancel(TTMActions.TRACK_THUMBS_DOWN);

// Remove all time to music events
export const timeToMusicClear = createAction(StatsActions.TTM_CLEAR)();
export type TtmClearAction = ReturnType<typeof timeToMusicClear>;

interface TtmTransitionPayload {
  audioType: $TSFixMe;
}

const timeToMusicTransition = createAction(StatsActions.TTM_TRANSITION, (audioType: $TSFixMe) => ({
  audioType,
}))<TtmTransitionPayload>();
export type TtmTransitionAction = ReturnType<typeof timeToMusicTransition>;

// Set all of the TTM events to the current time and change their audio type.
// This is useful when you want to measure ttm from the end of the ad but don't know what TTM events are queued.
export const timeToMusicTransitionFromMusic = (): TtmTransitionAction =>
  timeToMusicTransition(TTMAudioTypes.MUSIC);
export const timeToMusicTransitionFromVideoAd = (): TtmTransitionAction =>
  timeToMusicTransition(TTMAudioTypes.VIDEO_AD);

interface UpdatePreviousPlayedHarnessParams extends $TSFixMe {}

export const updatePreviousPlayedHarness = createAction(
  StatsActions.UPDATE_PREVIOUS_PLAYED_HARNESS,
  (params: UpdatePreviousPlayedHarnessParams) => params,
)<UpdatePreviousPlayedHarnessParams>();
export type UpdatePreviousPlayedHarnessAction = ReturnType<typeof updatePreviousPlayedHarness>;

export const bufferingStart = createAction(StatsActions.BUFFERING_START)();
export type BufferingStartAction = ReturnType<typeof bufferingStart>;

export const bufferingStop = createAction(StatsActions.BUFFERING_STOP)();
export type BufferingStopAction = ReturnType<typeof bufferingStop>;
